import React, { useEffect, useState } from 'react';
import PhysicianPagesLinkModal from '@medflex/components/stories/PhysicianPagesLinkModal';
import commons from '@medflex/commons';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showAlertToast, showSuccessToast } from '@medflex/components/stories/Toast';
import config from '@medflex/utils/config';
import { TRACKING_ACTIONS, TRACKING_ELEMENT_TYPES, trackEvent } from '@medflex/utils/Tracking';
import useUserProfile from '../hooks/useUserProfile';
import useModal from '../hooks/useModal';

const PhysicianPagesLinkModule = () => {
  const { userProfile, isLoadingUserProfile, isUpdatingContactPage, editContactPage } =
    useUserProfile();
  const { close } = useModal();
  const [isSubmitted, setIsSubmitted] = useState();
  const { contactPage: errors = {} } = useSelector(state => state.errors);
  const { t } = useTranslation('physician');

  const defaultText = commons.constant.contactPage.personalNote.getText();

  const { slugWithId } = userProfile.attributes;
  const pagesLink = `${config.PHYSICIAN_PAGES_URL}/${slugWithId}`;

  useEffect(() => {
    const { update: error } = errors;
    if (isSubmitted && !isUpdatingContactPage) {
      if (error) {
        showAlertToast(
          t('toasts.contact_page.failure.title'),
          t('toasts.contact_page.failure.text'),
          { toastId: 'multiPatientInviteFailed' },
        );
        setIsSubmitted(false);
        return;
      }
      showSuccessToast(
        t('toasts.contact_page.success.title'),
        t('toasts.contact_page.success.text', { allowHtml: true, url: pagesLink || '' }),
        { toastId: 'contactPageSuccess' },
      );
      close({ modal: 'pages' });
    }
  }, [errors, isSubmitted, isUpdatingContactPage]);

  if (isLoadingUserProfile) {
    return null;
  }

  const handleSubmit = ({ personalNote: text }) => {
    if (!isSubmitted) {
      const { pages } = userProfile.attributes;
      const previousPersonalNote = (userProfile && pages.personalNote) || null;
      const isDefault = text === defaultText;
      const newPersonalNote = isDefault ? null : text;
      editContactPage({
        personalNote: newPersonalNote,
      });
      if (previousPersonalNote !== newPersonalNote) {
        trackEvent({
          zone: 'PhysicianPagesLinkModal_PERSONAL_NOTE',
          action: TRACKING_ACTIONS.SUBMIT,
          elementType: TRACKING_ELEMENT_TYPES.FORM,
          actionText: isDefault ? 'default_text' : 'custom_text',
        });
      }

      setIsSubmitted(true);
    }
  };

  return (
    <PhysicianPagesLinkModal
      onClose={() => close({ modal: 'pages' })}
      onSubmit={handleSubmit}
      isLoading={isUpdatingContactPage}
      isIndexed={
        userProfile &&
        userProfile.attributes.pages &&
        userProfile.attributes.pages.metaRobotsContent === 'index'
      }
      personalNote={
        userProfile && userProfile.attributes.pages && userProfile.attributes.pages.personalNote
      }
    />
  );
};

export default PhysicianPagesLinkModule;
